import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import {
  setAvailableMics,
  setMicSelected,
  startRecord,
  stopRecord,
  scribeCreateTranscript,
} from '../../actions';
import AudioRecorder from './AudioRecorder';

const mapStateToProps = ({
  scribeConversation: {
    availableMics,
    hasRecorded,
    inTwilioCalls,
    micIdSelected,
    recording,
    speechLang,
    status,
  },
  scribeSession: { captioner },
  scribeTranscriptUI: { fullScreen, electronCaptionMode },
}) => ({
  availableMics,
  fullScreen,
  electronCaptionMode,
  hasRecorded,
  inTwilioCalls,
  micIdSelected,
  recording,
  speechLang,
  status,
  user: captioner,
});

export default withSnackbar(
  connect(
    mapStateToProps,
    {
      setMicSelected,
      scribeCreateTranscript,
      setAvailableMics,
      startRecord,
      stopRecord,
    }
  )(AudioRecorder)
);
